import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';
import {
  FindingsStatusPillParams,
} from '@uigy/shared/components/ui-status-pill/ui-status-pill-typed/constants/findings';
import {
  StatusPillType,
} from '@uigy/shared/components/ui-status-pill/ui-status-pill-typed/ui-status-pill-typed.enums';
import {
  StatusPillTypedParams,
  StatusPillTypeStatuses,
} from '@uigy/shared/components/ui-status-pill/ui-status-pill-typed/ui-status-pill-typed.interfaces';
import { UiStatusPillComponent } from '@uigy/shared/components/ui-status-pill/ui-status-pill.component';

@Component({
  selector: 'app-ui-status-pill-typed',

  imports: [
    UiStatusPillComponent,
  ],
  templateUrl: './ui-status-pill-typed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiStatusPillTypedComponent {
  public languageService = inject(LanguageService);
  public pillType = input.required<StatusPillType>();
  public pillStatus = input.required<StatusPillTypeStatuses>();
  public pillParams : Signal<StatusPillTypedParams> = computed(() => {
    switch (this.pillType()) {
      case StatusPillType.findings:
        return FindingsStatusPillParams[this.pillStatus()];
    }
  });
}
